(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lm-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.querySelector('[data-lm-more]')?.addEventListener('click', event => {
        section.classList.add('lm-expanded');
        event.currentTarget.setAttribute('aria-expanded', 'true');
        event.currentTarget.hidden = true;
      });
    });
    root.querySelectorAll('[data-lm-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const mediaMap = JSON.parse(section.querySelector('[data-lm-media-map]').textContent);
      const gallery = section.querySelector('.lm-gallery-grid');
      const slides = [...gallery.querySelectorAll('[data-media-id]')];
      const dots = [...section.querySelectorAll('[data-lm-gallery-dot]')];
      const previews = [...section.querySelectorAll('[data-lm-preview]')];
      const reducedMotion = () => matchMedia('(prefers-reduced-motion:reduce)').matches;
      const activateDot = id => dots.forEach(dot => {
        const active = dot.dataset.lmGalleryDot === String(id);
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
      const showMedia = id => {
        const media = slides.find(item => item.dataset.mediaId === String(id));
        if (!media) return;
        if (matchMedia('(max-width:749px)').matches) {
          gallery.scrollTo({left:media.offsetLeft - gallery.offsetLeft - 16, behavior:reducedMotion() ? 'auto' : 'smooth'});
        } else {
          gallery.prepend(media);
        }
        activateDot(id);
      };
      dots.forEach(dot => dot.addEventListener('click', () => showMedia(dot.dataset.lmGalleryDot)));
      previews.forEach(button => button.addEventListener('click', () => {
        const colour = button.dataset.lmPreview;
        previews.forEach(preview => preview.setAttribute('aria-pressed', String(preview === button)));
        section.querySelector('[data-lm-selected]').textContent = colour;
        showMedia(mediaMap[colour] || colour);
      }));
      if ('IntersectionObserver' in window) {
        const galleryObserver = new IntersectionObserver(entries => {
          if (!matchMedia('(max-width:749px)').matches) return;
          const visible = entries.find(entry => entry.isIntersecting && entry.intersectionRatio > .6);
          if (visible) activateDot(visible.target.dataset.mediaId);
        }, {root:gallery, threshold:.65});
        slides.forEach(slide => galleryObserver.observe(slide));
      }
      const dialog = section.querySelector('.lm-size-dialog');
      section.querySelector('[data-lm-size-open]')?.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-lm-size-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      section.querySelector('[data-lm-sticky-button]').addEventListener('click', event => {
        event.preventDefault();
        const bundles = section.querySelector('.lm-bundle-area');
        bundles.focus({preventScroll:true});
        bundles.scrollIntoView({behavior:reducedMotion() ? 'auto' : 'smooth', block:'start'});
      });
      if ('IntersectionObserver' in window) {
        const sticky = section.querySelector('[data-lm-sticky]');
        new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold:0}).observe(section.querySelector('[data-lm-submit]'));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
